import type { UserProfile } from '../types/user';

export function hasCompletedOnboarding(profile: UserProfile): boolean {
  if (profile.role === 'operations' || profile.role === 'system-admin') return true;
  return profile.onboardingComplete && profile.application?.kind === profile.role;
}
